import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppRole } from "@/service/AppRoleService";

interface User {
  name: string;
  email: string;
}

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  user: User | null;
  error: string | null;
  expiresAt: number | null;
}

const initialState: AuthState = {
  token: null,
  isAuthenticated: false,
  user: null,
  error: null,
  expiresAt: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (
      state,
      action: PayloadAction<{
        token: string;
        user: User;
        expiresAt: number;
      }>,
    ) => {
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.error = null;
      state.expiresAt = action.payload.expiresAt;
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
      state.expiresAt = null;
    },
    loginFailed: (state, action: PayloadAction<string>) => {
      state.token = null;
      state.isAuthenticated = false;
      state.user = null;
      state.error = action.payload;
      state.expiresAt = null;
    },
  },
});

export const { loginSuccess, logout, loginFailed } = authSlice.actions;

export default authSlice.reducer;
